import { render, staticRenderFns } from "./PlanejamentoAlojamento.vue?vue&type=template&id=c7ef02cc&scoped=true&"
import script from "./PlanejamentoAlojamento.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAlojamento.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAlojamento.vue?vue&type=style&index=0&id=c7ef02cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ef02cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSheet,VSpacer})
